import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useEffect, useRef, useState } from "react";
import "./style.css";
import { getDataFromApi } from "../../APIs";
import moment from "moment";
import {
  DATE_FORMAT,
  SEARCHEVENTS_API,
  SEARCHTEAM_API,
  SEARCHTICKETCATEGORIES_API,
  SEARCHTOURNAMENTS_API,
  SEARCHVENUES_API,
} from "../../constants";
import {
  Link,
  createSearchParams,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
// import { StarIcon } from "../Footer/svgIcons";
import { CrossIcon, FilterIcon, HeaderCloseIcon } from "../GlobalIcons";
import { filterDataContext } from "../../App";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import OutsideClick from "../OutsideClick";
import CustomModal from "../CustomModal";
import { EVENTSPAGE } from "../../constants/RoutingPath";

const GlobalSearchResult = ({ ForMobile }) => {
  const {
    bottomSheetview,
    setBottomSheetView,
    showSorting,
    setShowSorting,
    customModel,
    setCustomModel,
    setViewMoreClicked,
  } = useContext(filterDataContext);
  const [headerSearch, setHeaderSearch] = useState("");
  const [teamResult, setTeamResult] = useState([]);
  const [tournamentResult, setTournamentResult] = useState([]);
  const [venueResult, setVenueResult] = useState([]);
  const [categoriesResult, setCategoriesResult] = useState([]);
  const [eventsResult, setEventsResult] = useState([]);
  const [groupedCategorie, setGroupedCategorie] = useState({});
  const [showExpandSearchBar, setShowExpandSearchBar] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const closeRef = useRef();
  const inputRef = useRef();

  const getAndSetData = async () => {
    const [teams, tournaments, venues, categories, events] = await Promise.all([
      getDataFromApi(SEARCHTEAM_API, headerSearch),
      getDataFromApi(SEARCHTOURNAMENTS_API, headerSearch),
      getDataFromApi(SEARCHVENUES_API, headerSearch),
      getDataFromApi(SEARCHTICKETCATEGORIES_API, headerSearch),
      getDataFromApi(SEARCHEVENTS_API, headerSearch),
    ]);
    teams && setTeamResult(teams.data.data);
    tournaments && setTournamentResult(tournaments.data.data);
    venues && setVenueResult(venues.data.data);
    categories && setCategoriesResult(categories.data.data);
    events && setEventsResult(events.data.data);
  };

  const getGroupedCategories = () => {
    const gropupedVenue = {};
    categoriesResult.forEach((item) => {
      const { venue_name, category_name } = item;
      if (gropupedVenue[venue_name]) {
        gropupedVenue[venue_name].push(category_name);
      } else {
        gropupedVenue[venue_name] = [category_name];
      }
    });
    setGroupedCategorie(gropupedVenue);
  };

  useEffect(() => {
    if (categoriesResult.length > 0) {
      getGroupedCategories();
    }
  }, [categoriesResult]);

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      if (headerSearch.trim() !== "") {
        getAndSetData();
      }
    }, 300);
    return () => clearTimeout(debounceTimer);
  }, [headerSearch]);

  const closeSearchBar = () => {
    setShowExpandSearchBar(false);
    setHeaderSearch("");
    inputRef.current.blur();
  };

  const openSearchBar = () => {
    if (!showExpandSearchBar) {
      setShowExpandSearchBar(true);
    }
  };

  const handleGlobalSearchClick = () => {
    setViewMoreClicked(true);
  };

  return (
    <div
      ref={closeRef}
      className={`header_input ${
        ForMobile !== "MobileGlobalSearch" && "mobile_hide"
      } ${
        showExpandSearchBar === true && window.innerWidth > 767 ? "expand" : ""
      } ${
        ForMobile === "MobileGlobalSearch" &&
        location.pathname.split("/")[1] === "ticket"
          ? "hide_filter_mob_global"
          : ""
      }`}
    >
      <input
        ref={inputRef}
        type="text"
        placeholder="Search"
        value={headerSearch}
        onChange={(e) => {
          setHeaderSearch(e.target.value);
        }}
        onFocus={openSearchBar}
      />

      <div
        className="header_pop_cross"
        onClick={() => {
          closeSearchBar();
        }}
      >
        <span>
          {" "}
          <HeaderCloseIcon />
        </span>
      </div>
      {showExpandSearchBar === true && (
        <OutsideClick
          closeRef={closeRef}
          func={closeSearchBar}
          state={showExpandSearchBar}
        />
      )}
      <FontAwesomeIcon icon={faMagnifyingGlass} onClick={openSearchBar} />
      {ForMobile === "MobileGlobalSearch" ? (
        location.pathname === "/" || location.pathname === "/events" ? (
          <span
            onClick={() => {
              setShowSorting(true);
              setBottomSheetView(true);
            }}
            className="Filter_sec"
          >
            <FilterIcon />
          </span>
        ) : (
          ""
        )
      ) : (
        ""
      )}

      {headerSearch.length > 0 && (
        <>
          {teamResult.length === 0 &&
          tournamentResult.length === 0 &&
          venueResult.length === 0 &&
          categoriesResult.length === 0 &&
          eventsResult.length === 0 ? (
            <div
              className={`search_result_poppup`}
              id={headerSearch.length > 0 ? "active" : ""}
              style={{
                width: "100%",
                justifyContent: "center",
                color: "white",
                fontSize: "16px",
              }}
            >
              No Result Found
            </div>
          ) : (
            <div
              className={`search_result_poppup`}
              id={headerSearch.length > 0 ? "active" : ""}
            >
              {teamResult.length > 0 && (
                <div className="Sections_of_result">
                  <h3>Teams</h3>
                  <ul>
                    {teamResult?.map((team, index) => (
                      <Link
                        key={index}
                        to={{
                          pathname: EVENTSPAGE,
                          search: `?${createSearchParams({
                            sport_type:
                              team.sport_type === "soccer"
                                ? "football"
                                : team.sport_type === "formula1"
                                ? "motorsport"
                                : team.sport_type,
                            team_name: team.official_name,
                          })}`,
                        }}
                        onClick={() => {
                          handleGlobalSearchClick();
                          closeSearchBar();
                        }}
                      >
                        <li key={index}>{team.official_name}</li>
                      </Link>
                    ))}
                  </ul>
                </div>
              )}

              {tournamentResult.length > 0 && (
                <div className="Sections_of_result">
                  <h3>Tournaments</h3>
                  <ul>
                    {tournamentResult?.map((tournament, index) => (
                      <Link
                        key={index}
                        to={{
                          pathname: EVENTSPAGE,
                          search: `?${createSearchParams({
                            sport_type:
                              tournament.sport_type === "soccer"
                                ? "football"
                                : tournament.sport_type === "formula1"
                                ? "motorsport"
                                : tournament.sport_type,
                            tournament_name: tournament.slug,
                          })}`,
                        }}
                        onClick={() => {
                          handleGlobalSearchClick();
                          closeSearchBar();
                        }}
                      >
                        <li key={index}>{tournament.official_name}</li>
                      </Link>
                    ))}
                  </ul>
                </div>
              )}

              {venueResult.length > 0 && (
                <div className="Sections_of_result">
                  <h3>Venues</h3>
                  <ul>
                    {venueResult?.map((venue, index) => (
                      <Link
                        key={index}
                        to={{
                          pathname: EVENTSPAGE,
                          search: `?${createSearchParams({
                            sport_type: searchParams.get("sport_type")
                              ? searchParams.get("sport_type")
                              : "football",
                            venue: venue.official_name,
                          })}`,
                        }}
                        onClick={() => {
                          handleGlobalSearchClick();
                          closeSearchBar();
                        }}
                      >
                        <li key={index}>
                          <h6>{venue.official_name}</h6>
                          <p>{`${venue.city} (${venue.country})`}</p>
                        </li>
                      </Link>
                    ))}
                  </ul>
                </div>
              )}

              {categoriesResult.length > 0 && (
                <div className="Sections_of_result">
                  <h3>Ticket categories</h3>
                  <ul>
                    {Object.entries(groupedCategorie)
                      ?.slice(0, 5)
                      .map(([venue_name, categories], index) => {
                        return (
                          <Link
                            key={index}
                            to={{
                              pathname: EVENTSPAGE,
                              search: `?${createSearchParams({
                                sport_type: searchParams.get("sport_type")
                                  ? searchParams.get("sport_type")
                                  : "football",
                                venue: venue_name,
                              })}`,
                            }}
                            onClick={() => {
                              handleGlobalSearchClick();
                              closeSearchBar();
                            }}
                          >
                            <li>
                              <h6>{venue_name}</h6>
                              {categories?.slice(0, 3).map((item, index) => (
                                <React.Fragment key={index}>
                                  <p>{item}</p>
                                  {index === 2 && categories.length > 3 && (
                                    <p>...</p>
                                  )}
                                </React.Fragment>
                              ))}
                            </li>
                          </Link>
                        );
                      })}
                  </ul>
                </div>
              )}

              {eventsResult.length > 0 && (
                <div className="Sections_of_result">
                  <h3>Events</h3>
                  <ul>
                    {eventsResult.map((events, index) => (
                      <Link
                        to={`/ticket/${events.event_id}`}
                        key={index}
                        onClick={() => {
                          closeSearchBar();
                        }}
                      >
                        <li>
                          <h6>{events.event_name}</h6>
                          <p>
                            {moment(events.date_start).format(DATE_FORMAT)}{" "}
                            {events.venue_name}, {events.city} (
                            {events.iso_country})
                          </p>
                        </li>
                      </Link>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default GlobalSearchResult;
